import { useEffect, useRef, useState } from 'react'

export default function CloudflareCaptcha({ onVerify }) {
  const containerRef = useRef(null)
  const widgetIdRef = useRef(null)
  const [loaded, setLoaded] = useState(false)

  // Load only once when script is available
  useEffect(() => {
    const renderCaptcha = () => {
      if (!window.turnstile || !containerRef.current || widgetIdRef.current) return

      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: process.env.NEXT_PUBLIC_CLOUDFLARE_CAPTCHA_SITEKEY,
        callback: (token) => onVerify(token),
        'expired-callback': () => onVerify(null),
        'error-callback': () => onVerify(null),
        theme: 'light',
      })

      setLoaded(true)
    }

    // Wait for script to load
    if (window.turnstile) {
      renderCaptcha()
    } else {
      const interval = setInterval(() => {
        if (window.turnstile) {
          renderCaptcha()
          clearInterval(interval)
        }
      }, 100)
      return () => clearInterval(interval)
    }

    // Cleanup widget on unmount
    return () => {
      if (widgetIdRef.current && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current)
        } catch {}
        widgetIdRef.current = null
      }
    }
  }, [])

  return (
    <div
      ref={containerRef}
      className="cf-turnstile"
      data-loaded={loaded ? 'true' : 'false'}
    ></div>
  )
}
